// Contact Context
export const ADD_CONTACT = 'ADD_CONTACT';
export const GET_CONTACTS = 'GET_CONTACTS';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS';
export const FILTER_CONTACTS = 'FILTER_CONTACTS';
export const CONTACT_ERROR = 'CONTACT_ERROR';



// Alert Context
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';



//Task Context
export const ADD_TASK = 'ADD_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';
export const GET_TASKS_TODO = 'GET_TASKS_TODO';
export const GET_TASKS_DONE = 'GET_TASKS_DONE';
export const TASK_ERROR = 'TASK_ERROR';
export const UPDATE_TASK = 'UPDATE_TASK';
export const CLEAR_TASKS = 'CLEAR_TASKS';

//Task Context
export const ADD_POST = 'ADD_POST';
export const REMOVE_POST = 'REMOVE_POST';
export const GET_POSTS = 'GET_POSTS';
export const POST_ERROR = 'POST_ERROR';
export const UPDATE_POST = 'UPDATE_POST';
export const CLEAR_POSTS = 'CLEAR_POSTS';
// Message Context

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const GET_MESSAGES = 'GET_MESSAGES';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const FILTER_MESSAGES = 'FILTER_MESSAGES';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const SET_CURRENT = 'SET_CURRENT';
export const CLEAR_CURRENT = 'CLEAR_CURRENT';
export const REMOVE_CURRENT = 'REMOVE_CURRENT';
export const MESSAGE_ERROR = 'MESSAGE_ERROR';


// Drawing Context
export const ADD_DRAWING = 'ADD_DRAWING';
export const GET_DRAWINGS = 'GET_DRAWINGS';
export const DELETE_DRAWING = 'DELETE_DRAWING';
export const UPDATE_DRAWING = 'UPDATE_DRAWING';
export const CLEAR_DRAWINGS = 'CLEAR_DRAWINGS';
export const DRAWING_ERROR = 'DRAWING_ERROR';
export const FILTER_DRAWINGS = 'FILTER_DRAWINGS';
// Line Context
export const ADD_LINE = 'ADD_LINE';
export const GET_LINES = 'GET_LINES';
export const DELETE_LINE = 'DELETE_LINE';
export const UPDATE_LINE = 'UPDATE_LINE';
export const CLEAR_LINES = 'CLEAR_LINES';
export const LINE_ERROR = 'LINE_ERROR';
export const FILTER_LINES = 'FILTER_LINES';
// Point Context
export const ADD_POINT = 'ADD_POINT';
export const GET_POINTS = 'GET_POINTS';
export const DELETE_POINT = 'DELETE_POINT';
export const UPDATE_POINT = 'UPDATE_POINT';
export const CLEAR_POINTS = 'CLEAR_POINTS';
export const POINT_ERROR = 'POINT_ERROR';
export const FILTER_POINTS = 'FILTER_POINTS';
//Post Context

export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const FETCH_ALL = 'FETCH_ALL';
export const LIKE = 'LIKE';
